module.exports = "/_next/static/images/convertible-da11e9381b634ce20b386cca3e87f28c.jpg";